import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import  "./static/css/bootstrap.css";
import  "./static/css/Custom.css";
import cognitoAuth from './cognito'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  cognitoAuth, 
  render: h => h(App)
}).$mount('#app')
